import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'checkbox-button-input-ctrl',
  templateUrl: './checkbox-button-input.component.html',
  styleUrls: ['./checkbox-button-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxButtonInputComponent,
    multi: true
  }]
})
export class CheckboxButtonInputComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {uppercase:false, fxFill:false};

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
  }

  isChecked(): boolean{
    return this.control.value;
  }

  toogleValue(){
    this.control.setValue(!this.control.value);
  }

  

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
